export default {
  methods: {
    validateAndHideUi () {
      this.validate(false)
    },
    validateAndShowUi () {
      this.validate(true)
    },
    // In order to maintain backwards compatibility, I'm leaving this method signature alone
    // though flipping the default value, because even though the old default was false,
    // the internals of the method essentially ignored that.
    validate (forceShowUiValidation = true) {
      forceShowUiValidation = forceShowUiValidation === null ? true : forceShowUiValidation
      let options = { forceUiValidation: forceShowUiValidation ? 'show' : 'hide' }

      if (options.forceUiValidation === 'show') {
        // Since we're validating, we want to make sure UI shows
        this.hideValidationUi = false
        // If we want to force the UI validation to show (for VALID state, that is), we'll need to mark the
        // field as dirty
        this.isDirty = true
      } else if (options.forceUiValidation === 'hide') {
        this.hideValidationUi = true
      }

      // The validation dicationary is shared among all components. In our case,
      // we don't want this, because we may have multiple forms that share field
      // names, and the expected behavior is that you could set different (or none)
      // error messages on fields across forms, even if they share the same name
      // So, before validating, we'll update the dictionary with the custom
      // messages for this specific field
      this.$validator.updateDictionary(this.validationDictionary)
      return this.$validator.validateAll().catch(Function.prototype) // Noop function
    },
    clearValidation () {
      this.hideValidationUi = true
    }
  }
}



// WEBPACK FOOTER //
// ./src/frontend/mixins/validate.js